import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";

interface CategoryTypesTableProps {
}

export const CategoryTypesTable: React.FC<CategoryTypesTableProps> = () => {

    const categoryTypesState = useAppSelector(state => state.categoryTypes);

    return (
        <>
            <table className="data">
                <thead>
                <tr>
                    <th>Nimi</th>
                    <th className="right w150"></th>
                </tr>
                </thead>
                <tbody>
                {categoryTypesState.categoryTypes.map(row => {
                    return (
                        <tr key={row.id}>
                            <td>
                                {row.name}
                            </td>
                            <td className="action">
                                <Link to={`/category-types/${row.id}/modify`}>Muuda</Link>
                                <span>|</span>
                                <Link to={`/category-types/${row.id}/delete`}>Kustuta</Link>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
            <ul className="table-actions">
                <li>
                    <Link to="/category-types/new">
                        <strong>Lisa kategooria tüüp</strong>
                    </Link>
                </li>
            </ul>
        </>
    );

}